import { getAPIUrl } from '../apiUtils';

export const getAdminBaseUrl = (accountId) => {
  return `${getAPIUrl(accountId)}/administration`;
};
